import { create } from "zustand";
import axios from "axios";
import LinkType from "../../common/constants/LinkType";

export interface ILink {
  linkID: number;
  linkTypeID: number;
  labelDisplayTextKey: string;
  hyperlinkUrl: string | null;
  image: ImageBitmap | null;
  sortOrder: number;
  writeTimestamp: string;
}

type LinkStore = {
  links: ILink[];
  locale: string;
  loading: Boolean;
  hasErrors: Boolean;
  getFilteredLinks: (linkType: LinkType) => (state: LinkStore) => ILink[];
  fetchLinks: (apiBaseUrl: string, locale: string) => Promise<void>;
};

const useLinkStore = create<LinkStore>((set) => ({
  links: [],
  locale: "",
  loading: false,
  hasErrors: false,
  getFilteredLinks: (linkType) => (state) => {
    return state.links.filter((link) => link.linkTypeID === linkType);
  },
  fetchLinks: async (apiBaseUrl, locale) => {
    // If language is empty string, it's still intializing
    if (apiBaseUrl === "" || locale === "") {
      return;
    }

    set((state) => ({ hasErrors: false, loading: true }));
    try {
      console.log("Fetching links");
      const response = await axios.get(
        `${apiBaseUrl}/api/display/links?localeName=${locale}`
      );
      set((state) => ({
        links: (state.links = response.data.links),
        locale: locale,
        loading: false,
      }));
    } catch (err) {
      set((state) => ({ hasErrors: true, loading: false }));
    }
  },
}));

export default useLinkStore;
